/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ListTablePage from '../../templates/listTableTemplate/listTableTemplate';
import './tabItem.scss';

/**
 * Tabs splits a big content into different sections.
 * It contains tab children as dependant atom.
 * Each tab contains the specific content of the section.
 */
const Tabs = (props) => {
  const {
    value,
    children,
    onChange,
  } = props;
  const [activeTab, setActiveTab] = useState(value);

  const onClickTab = (tabSelected, event) => {
    event.preventDefault();
    setActiveTab(tabSelected);
    // onChange(tabSelected);
  };
  return (
    <div>
      <ul className="nav nav-tabs">
        { Array.isArray(children.tabs) === true
      && children.tabs.map((tab, index) => (
        <li key={tab.eventKey} className="nav-item">
          <a className={`nav-link tab-cursor ${tab.eventKey === activeTab ? 'active' : 'inactive'}`} onClick={(e) => onClickTab(tab.eventKey, e)} href={tab.href}>{tab.tabName}</a>
        </li>
      ))}
      </ul>
      <div className="">
        <ListTablePage configFile={children.tabs.find((child) => child.eventKey === activeTab)} />
      </div>
    </div>
  );
};

Tabs.propTypes = {
  /**
   * Initial tab
   */
  value: PropTypes.string,
  /**
   * Function to bind the onChange event
   */
  onChange: PropTypes.func,
  /**
   * Tab components, they define the content.
   */
  children: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.arrayOf(PropTypes.shape({}))]).isRequired,
};

Tabs.defaultProps = {
  value: '',
  onChange: () => {},
};

/**
 * Child of Tabs.
 */
export const Tab = (props) => {
  const {
    eventKey,
    title,
    href,
    children,
  } = props;

  return children;
};

Tab.propTypes = {
  /**
   * Tab name
   */
  eventKey: PropTypes.string.isRequired,
  /**
   * Label of the tab
   */
  title: PropTypes.string.isRequired,
  /**
   * URL linked to the routering react component
   */
  href: PropTypes.string.isRequired,
  /**
   * JSX content
   */
  children: PropTypes.node,
};

export default Tabs;
